module.exports = __webpack_public_path__ + "3c72a2672ef6fb9deeea5c6bbdb283ce.png";